export default __webpack_public_path__ + "static/media/puzz.0fe89724.jpg";